import { __ }    from '@wordpress/i18n';
import { range } from '../../../utils/helpers';

const ARROW_SETS = {
	arrows:  { prev: '←', next: '→' },
	chevron: { prev: '‹', next: '›' },
	double:  { prev: '«', next: '»' },
	angle:   { prev: '❮', next: '❯' },
	long:    { prev: '⟵', next: '⟶' },
};

export default function Pagination( { currentPage, totalPages, onPageChange, style, arrowStyle = 'arrows' } ) {
	if ( totalPages <= 1 ) return null;

	const pages  = buildPageRange( currentPage, totalPages );
	const arrows = ARROW_SETS[ arrowStyle ] ?? ARROW_SETS.arrows;

	return (
		<nav className="mwsb-pagination" style={ style } aria-label={ __( 'Product pagination', 'mwsb' ) }>
			<button
				className="mwsb-pagination__btn mwsb-pagination__btn--prev mwsb-pagination__btn--arrow"
				disabled={ currentPage === 1 }
				onClick={ () => onPageChange( currentPage - 1 ) }
				aria-label={ __( 'Previous page', 'mwsb' ) }
			>
				{ arrows.prev }
			</button>

			{ pages.map( ( page, i ) =>
				page === '...' ? (
					<span key={ `dots-${ i }` } className="mwsb-pagination__dots">…</span>
				) : (
					<button
						key={ page }
						className={ `mwsb-pagination__btn${ page === currentPage ? ' mwsb-pagination__btn--active' : '' }` }
						onClick={ () => onPageChange( page ) }
						aria-current={ page === currentPage ? 'page' : undefined }
					>
						{ page }
					</button>
				)
			) }

			<button
				className="mwsb-pagination__btn mwsb-pagination__btn--next mwsb-pagination__btn--arrow"
				disabled={ currentPage === totalPages }
				onClick={ () => onPageChange( currentPage + 1 ) }
				aria-label={ __( 'Next page', 'mwsb' ) }
			>
				{ arrows.next }
			</button>
		</nav>
	);
}

function buildPageRange( current, total ) {
	if ( total <= 7 ) return range( 1, total );

	if ( current <= 4 ) {
		return [ ...range( 1, 5 ), '...', total ];
	}
	if ( current >= total - 3 ) {
		return [ 1, '...', ...range( total - 4, total ) ];
	}
	return [ 1, '...', ...range( current - 1, current + 1 ), '...', total ];
}
